import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-camera-qiuji",
  "use": "icon-camera-qiuji-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-camera-qiuji\"><path fill=\"#0000FF\" d=\"M60.416 257.536c0 33.28-3.072 176.128 0 226.816 13.312 23.552 38.4 43.52 71.168 60.416 6.144 186.88 174.08 336.896 380.928 336.896 207.36 0 375.808-151.04 380.928-338.944 32.768-16.384 57.856-35.84 71.168-58.368V257.536C817.664 102.4 202.752 104.96 60.416 257.536z m592.896 496.64h-8.704c-19.456 32.768-71.168 56.832-132.608 56.832s-113.152-23.552-132.608-56.832h-8.704v-184.32c0-77.824 63.488-141.312 141.312-141.312s141.312 63.488 141.312 141.312v184.32z m240.64-349.184C755.2 321.536 266.24 320.512 131.584 404.992c-2.56-26.112-1.024-102.4-1.024-119.296 170.496-98.304 633.344-91.136 763.392 2.56v116.736zM425.472 616.448c0 47.616 38.4 86.528 86.528 86.528 47.616 0 86.528-38.4 86.528-86.528 0-47.616-38.4-86.528-86.528-86.528-47.616 0-86.528 38.4-86.528 86.528 0-0.512 0-0.512 0 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/camera-qiuji.svg
// module id = U7/F
// module chunks = 250